module.exports = __webpack_public_path__ + "static/35-WHAT-MAKES-US-HUMAN-WILL-MAKE-US-EMPLOYABLE-IN-THE-FUTURE-d5b7a75c350927450396be481e18d1de.jpg";